import createOrUpdateHiddenField from './createOrUpdateHiddenField';
import { safeLocalStorage } from './safeStorage';

const formatMyCars = (vehicle) =>
	`${vehicle.stockNumber} - ${vehicle.vehicleTitle}`;

const injectMyCars = (form) => {
	const myCarsKey = 'mycars-user';
	let trackedCount = 0;
	let savedCount = 0;

	if (!safeLocalStorage.getItem(myCarsKey)) {
		return;
	}

	const data = safeLocalStorage.getItem(myCarsKey);
	const myCarsUserData = JSON.parse(data);
	if (myCarsUserData && myCarsUserData.vehicles) {
		myCarsUserData.vehicles.forEach((vehicle) => {
			if (
				(vehicle.tracked || vehicle.newSave) &&
				vehicle.stockNumber &&
				vehicle.vehicleTitle
			) {
				let customFieldKey;
				let customFieldValue;
				if (vehicle.tracked && vehicle.newSave) {
					trackedCount += 1;
					savedCount += 1;
					customFieldKey = `_custom=Mycars Alert ${trackedCount}=1=${myCarsKey}`;
					customFieldValue = formatMyCars(vehicle);
					createOrUpdateHiddenField(
						form,
						customFieldKey,
						customFieldValue
					);
					customFieldKey = `_custom=Mycars Save ${savedCount}=1=${myCarsKey}`;
					createOrUpdateHiddenField(
						form,
						customFieldKey,
						customFieldValue
					);
				} else if (vehicle.tracked) {
					trackedCount += 1;
					customFieldKey = `_custom=Mycars Alert ${trackedCount}=1=${myCarsKey}`;
					customFieldValue = formatMyCars(vehicle);
					createOrUpdateHiddenField(
						form,
						customFieldKey,
						customFieldValue
					);
				} else if (vehicle.newSave) {
					savedCount += 1;
					customFieldKey = `_custom=Mycars Save ${savedCount}=1=${myCarsKey}`;
					customFieldValue = formatMyCars(vehicle);
					createOrUpdateHiddenField(
						form,
						customFieldKey,
						customFieldValue
					);
				}
			}
		});
	}
};

export default injectMyCars;
